import { required, minLength, sameAs, requiredIf } from 'vuelidate/lib/validators';

const validations = {
  firstName: {
    required,
    minLength: minLength(3),
  },
  lastName: {
    required,
    minLength: minLength(3),
  },
  phoneNumber: {
    minLength: minLength(6),
  },
  password: {
    minLength: minLength(6),
  },
  confirmPassword: {
    minLength: minLength(6),
    sameAs: sameAs('password'),
  },
  companyId: {
    required,
  },
  countryId: {
    required,
  },
  townId: {
    required,
  },
  address_1: {
    required,
  },
  shippingInfo: {
    firstName: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
    lastName: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
    phone: {
      minLength: minLength(6),
    },
    address_1: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
    countryId: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
    townId: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
    zipCode: {
      required: requiredIf(function() {
        return !this.sameAsBilling;
      }),
    },
  },
};

export default validations;